import type { HttpApiError } from '@backmarket/http-api'
import { getPricingEstimation } from '@backmarket/http-api/src/api-specs-buyback/seller/buyback-quotes'
import type { BuyBackQuotePricingEstimation } from '@backmarket/http-api/src/api-specs-buyback/seller/buyback-quotes.types'
import toastTranslations from '@backmarket/nuxt-layer-buyback/utils/Toast.translations'
import { $httpFetch } from '@backmarket/nuxt-module-http/$httpFetch'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useLogger } from '@backmarket/nuxt-module-logger/useLogger'
import { useTheToast } from '@backmarket/nuxt-module-toast/useTheToast'

export async function useGetPricingEstimations(
  grades: string[],
  productId: string,
  marketCode: string,
): Promise<BuyBackQuotePricingEstimation[]> {
  const logger = useLogger()
  const i18n = useI18n()
  const { openErrorToast } = useTheToast()

  try {
    return await $httpFetch(getPricingEstimation, {
      pathParams: {
        productId,
        marketCode,
      },
      queryParams: {
        grades,
      },
    })
  } catch (err) {
    openErrorToast({
      title: i18n(toastTranslations.toastErrorTitle),
      content: i18n(toastTranslations.toastErrorContent),
    })

    logger.error('[BUYBACK][API][QUOTES] Error getting pricing estimation', {
      error: err as HttpApiError,
      owners: ['bot-squad-circularity-order-lifecycle-front'],
    })
  }

  return []
}
